export default __webpack_public_path__ + "static/media/Gather Intel.09e6ddae.png";